import React from "react";
import { Modal, Button } from "react-bootstrap";

const LoanDetailsModal = ({ show, onHide, details, Acc_number }) => {
    console.log("Due Details",details)
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Loan Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Account Number : {Acc_number}
        {Array.isArray(details) &&
          details.map((data) => {
            return <>
              {/* <p>
                <strong>Account Number:</strong> {Acc_number}
              </p> */}
               <p>
                <strong>Installment due:</strong> {data.inst_amount_due}
              </p>
             {/* <p>
                <strong>Loan Type:</strong> {loanTypeDesc}
              </p>
              {Disb_amt && (
                <p>
                  <strong>Disbursed Amount:</strong> ₹{Disb_amt}
                </p>
              )}
              {Due_amt && (
                <p>
                  <strong>Due Amount:</strong> ₹{Due_amt}
                </p>
              )}
              {StartDate && (
                <p>
                  <strong>Start Date:</strong> {StartDate}
                </p>
              )}
              {MaturityDate && (
                <p>
                  <strong>Maturity Date:</strong> {MaturityDate}
                </p>
              )}
              {pledgeNetWeight && (
                <p>
                  <strong>Pledged Net Weight:</strong> {pledgeNetWeight}g
                </p>
              )}
              {RD_redemptionDate && (
                <p>
                  <strong>Redemption Date:</strong> {RD_redemptionDate}
                </p> */}
            </>;
          })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoanDetailsModal;
